import React, { useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styles from "./benefits.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import { about, why } from "../../../../CONTENT/physicians";
import { EASE } from "../../../../UTILS/ANIMATION/motionVariants";

const Benefits = () => {
  const [active, setActive] = useState(0);
  const tabs = useRef([]);
  const current = why.benefits[active];

  const onKeyDown = (e) => {
    const last = why.benefits.length - 1;
    const map = { ArrowRight: active + 1, ArrowDown: active + 1, ArrowLeft: active - 1, ArrowUp: active - 1, Home: 0, End: last };
    if (!(e.key in map)) return;
    e.preventDefault();
    const next = (map[e.key] + why.benefits.length) % why.benefits.length;
    setActive(next);
    tabs.current[next]?.focus();
  };

  return (
    <Section tone="light" id="why" labelledBy="why-title">
      <div className={styles.about}>
        {about.map((a) => (
          <div key={a.title}>
            <h2 className={styles.aboutTitle}>{a.title}</h2>
            <p className={styles.aboutText}>{a.text}</p>
          </div>
        ))}
      </div>

      <SectionIntro id="why-title" eyebrow="Why partner with KUR" title={why.title} lead={why.lead} />

      <div className={styles.layout}>
        <div role="tablist" aria-label="Benefits" aria-orientation="vertical" className={styles.tabs} onKeyDown={onKeyDown}>
          {why.benefits.map((b, i) => (
            <button
              key={b.title}
              ref={(el) => (tabs.current[i] = el)}
              type="button"
              role="tab"
              id={`benefit-tab-${i}`}
              aria-selected={i === active}
              aria-controls="benefit-panel"
              tabIndex={i === active ? 0 : -1}
              className={styles.tab}
              onClick={() => setActive(i)}
            >
              <img src={b.icon} alt="" className={styles.tabIcon} />
              <span>{b.title}</span>
            </button>
          ))}
        </div>
        <div id="benefit-panel" role="tabpanel" aria-labelledby={`benefit-tab-${active}`} className={styles.panel}>
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={current.title}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3, ease: EASE }}
              className={styles.panelInner}
            >
              <img src={current.icon} alt="" className={styles.panelIcon} />
              <div>
                <p className={styles.panelNum}>
                  {String(active + 1).padStart(2, "0")} / {String(why.benefits.length).padStart(2, "0")}
                </p>
                <h3 className={styles.panelTitle}>{current.title}</h3>
                <p className={styles.panelText}>{current.text}</p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </Section>
  );
};

export default Benefits;
